import { motion } from 'framer-motion';

const stories = [
  {
    id: 1,
    quote: "This organization saved my life. The breast cancer screening event helped me catch it early.",
    name: "Sarah M.",
    role: "Survivor & Advocate",
    image: 'https://public.readdy.ai/ai/img_res/51dc69ff5fffbbaa88ad45fd94d055bf.jpg',
  },
  {
    id: 2,
    quote: "The mental health workshops gave me tools to manage my anxiety and find peace.",
    name: "Michael T.",
    role: "Community Member",
    image: 'https://readdy.ai/api/search-image?query=portrait%20of%20young%20hispanic%20man%20looking%20peaceful%20and%20confident%20after%20mental%20health%20recovery%20with%20genuine%20smile%20against%20soft%20neutral%20background%20representing%20emotional%20wellness%20hope%20and%20personal%20growth%20with%20natural%20lighting%20and%20authentic%20expression&width=400&height=500&seq=story002&orientation=portrait',
  },
  {
    id: 3,
    quote: "Finding support after leaving an abusive relationship changed everything for me and my children.",
    name: "Jennifer L.",
    role: "Empowered Mother",
    image: 'https://readdy.ai/api/search-image?query=portrait%20of%20strong%20caucasian%20woman%20with%20children%20in%20background%20looking%20hopeful%20and%20empowered%20representing%20domestic%20violence%20survivor%20and%20protective%20mother%20with%20warm%20lighting%20against%20soft%20neutral%20background%20conveying%20strength%20resilience%20and%20new%20beginnings&width=400&height=500&seq=story003&orientation=portrait',
  },
];

export default function Impact() {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-charcoal mb-4">
              Community Impact Stories
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Real voices, real change. Hear from those whose lives have been transformed through our programs.
            </p>
          </motion.div>
        </div>

        {/* Stories Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {stories.map((story, index) => (
            <motion.div
              key={story.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className="group cursor-pointer"
            >
              <div className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all">
                {/* Image */}
                <div className="relative overflow-hidden h-80">
                  <img
                    src={story.image}
                    alt={story.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                  
                  {/* Quote Overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <blockquote className="font-serif text-xl text-white italic mb-3 leading-relaxed">
                      "{story.quote}"
                    </blockquote>
                    <div className="text-white">
                      <div className="font-semibold text-base">{story.name}</div>
                      <div className="text-sm text-white/80">{story.role}</div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Stats Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-20 bg-white rounded-3xl shadow-lg p-12"
        >
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-5xl font-bold text-coral mb-2">5,000+</div>
              <div className="text-gray-600 text-sm">People Educated</div>
            </div>
            <div>
              <div className="text-5xl font-bold text-purple mb-2">50+</div>
              <div className="text-gray-600 text-sm">Community Events</div>
            </div>
            <div>
              <div className="text-5xl font-bold text-pink mb-2">200+</div>
              <div className="text-gray-600 text-sm">Screenings Provided</div>
            </div>
            <div>
              <div className="text-5xl font-bold text-teal mb-2">100+</div>
              <div className="text-gray-600 text-sm">Active Volunteers</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}